import { useState, useEffect, useRef } from 'react';
import { baseURL } from "../../Store/base-url";
import { simplifyPath } from "../../Components/MapComponents/SimplifyPolyline";
import { useMap } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { hitViewportApi, isPanningMap, putViewportDriver, putViewportLocation, viewportLoadingStatusWorker } from '../../Actions/level.action';
import { fetchLogDeviceViewportDataUsingCancelToken } from '../../AxiosInterceptor/fetchLogDeviceViewportDataUsingCancelToken';

const useFetchVehicleDataViewPort = (method, url, body, threshold, fromTime, toTime, delay = 1000) => {
  const [isLoadingVp, setIsLoading] = useState(false);
  const timelineSelector = useSelector(state => state.timeline)
  const [resp, setResp] = useState([]);
  const [serverError, setServerError] = useState(null);
  const map = useMap();
  const dispatch = useDispatch();
  const levelDescription = useSelector(state => state.levels.driverLevels);
  const levelFilteredDrivers = useSelector(state => state.levels);

  const fetchVehicleDataTimerRef = useRef(null);

  const fetchData1 = async () => {
    let bbox = map.getBounds();

    let { lat: f_x, lng: f_y } = bbox.getSouthEast();
    let { lat: s_x, lng: s_y } = bbox.getNorthWest();

    let query = {
      bottomRightLat: f_x,
      bottomRightLng: f_y,
      topLeftLat: s_x,
      topLeftLng: s_y,
    }
    setIsLoading(true);
    dispatch(putViewportLocation(query));
    return query;
  }

  useEffect(() => {
    if (timelineSelector.clockData.event === "mouseup" && window.location.pathname.split("/").length === 1) {
      fetchData();
    }

  }, [timelineSelector.clockData.fromTime, timelineSelector.clockData.toTime])

  useEffect(() => {
    if (levelFilteredDrivers.hitViewportApi) {
      fetchData();
      dispatch(hitViewportApi(false))
    }

  }, [levelFilteredDrivers.hitViewportApi])

  const runDeferredFetchData = () => {
    clearTimeout(fetchVehicleDataTimerRef.current);
    fetchVehicleDataTimerRef.current = setTimeout(() => fetchData(), delay);
  }

  //Let user select his/her choice then fetch the data instead of fetching the data everytime an option is selected
  // useEffect(() => {
  //   if (levelDescription && levelFilteredDrivers.isPanningMap) {
  //     fetchData();
  //     // runDeferredFetchData()
  //   }
  //   //Stringifying the data so that the reference of levelDescription Object doesn't change and re-fetch the data continuosly 
  // }, [JSON.stringify(levelDescription)])

  //panning and dragging calling viewportApi
  useEffect(() => {
    map.on('zoom', () => {
      // fetchData();
      // runDeferredFetchData();
      dispatch(isPanningMap(true))
    })
    return () => {
      map.off('zoom')
    }

  }, [url, method, body.clientNumber, fromTime, toTime]);

  useEffect(() => {
    map.on('dragend', () => {
      // runDeferredFetchData();
      dispatch(isPanningMap(true))
    })
    return () => {
      map.off('dragend')
    }
  }, [url, method, body.clientNumber, fromTime, toTime]);

  const fetchData = async () => {
    const try1 = fetchData1();
    try {
      const { cancelPrevQuery, result, error } = await fetchLogDeviceViewportDataUsingCancelToken(
        baseURL,
        "json",
        url,
        method,
        {
          ...body,
          fromDateTime: `${fromTime}`,
          toDateTime: `${toTime}`,
          topLeftLat: (await try1).topLeftLat,
          topLeftLng: (await try1).topLeftLng,
          bottomRightLat: (await try1).bottomRightLat,
          bottomRightLng: (await try1).bottomRightLng,
          level1: levelDescription[0] ? levelDescription[0].map(function (el) { return el.trim(); }) : [],
          level2: levelDescription[1] ? levelDescription[1].map(function (el) { return el.trim(); }) : [],
          level3: levelDescription[2] ? levelDescription[2].map(function (el) { return el.trim(); }) : [],
          level4: levelDescription[3] ? levelDescription[3].map(function (el) { return el.trim(); }) : [],
          level5: levelDescription[4] ? levelDescription[4].map(function (el) { return el.trim(); }) : [],
          level6: levelDescription[5] ? levelDescription[5].map(function (el) { return el.trim(); }) : [],
          level7: levelDescription[6] ? levelDescription[6].map(function (el) { return el.trim(); }) : [],
          level8: levelDescription[7] ? levelDescription[7].map(function (el) { return el.trim(); }) : [],
          level9: levelDescription[8] ? levelDescription[8].map(function (el) { return el.trim(); }) : [],
          level10: levelDescription[9] ? levelDescription[9].map(function (el) { return el.trim(); }) : [],
        }
      );

      if (cancelPrevQuery) return;

      const data = result
      let newData = [];
      dispatch(viewportLoadingStatusWorker(isLoadingVp));
      for (let i = 0; i < data.length; i++) {
        const deviceId = data[i].deviceId;
        const deviceName = data[i].data.deviceName;
        const clientVehicleId = data[i].data.clientVehicleId;
        // comment down the 476 story 
        // const vehicleUtilizationStatus = data[i].vehicleUtilizationStatus == "" ? "No Data Found" : data[i].vehicleUtilizationStatus;
        // const driverScore = data[i].driverScore;
        const logRecordData = simplifyPath(data[i].data.locations, threshold);
        // const scoreColor = data[i].scoreColor;
        newData.push({ deviceId, logRecordData, deviceName, clientVehicleId });

      }
      dispatch(putViewportDriver(newData));
      setResp(newData);
    }
    catch (error) {
      setServerError(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    dispatch(viewportLoadingStatusWorker(isLoadingVp));
  }, [!isLoadingVp]);

  return { isLoadingVp, resp };
};

export default useFetchVehicleDataViewPort;

